import FJMobileImageToImageInput from './FJMobileImageToImageInput';
import { useSelector, useDispatch } from 'react-redux';
import { setSlicePromptAction } from '../../../redux/slices/FJSliceImageToImage';
import FJActionImageToImage from '../../../redux/action/FJActionImageToImage';
import useLocalStore from '../../../hooks/useLocalStore';

const FJMobileImageToImageInputContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const prompt = useSelector(state => state.imageToImage.prompt);
    const uploadImageInfo = useSelector(state => state.imageToImage.uploadImageInfo);

    const changePrompt = value => {
        dispatch(setSlicePromptAction(value));
    };
    const uploadImg = file => {
        dispatch(FJActionImageToImage.uploadImageAction(file));
    };

    return (
        <FJMobileImageToImageInput
            prompt={prompt}
            uploadImageInfo={uploadImageInfo}
            changePrompt={changePrompt}
            uploadImg={uploadImg}
        />
    );
};
export default FJMobileImageToImageInputContainer;
